import { useEffect, useState } from 'react';
import { Download } from 'lucide-react';

import { canInstall, onInstallChange, promptInstall } from '../install-prompt';
import { isStandalone, platform } from '../push-client';

/**
 * PRAT-201 — no Android, quando o Chrome deixa instalar, oferece "Instalar o
 * app" (vai para a tela inicial e abre como app). Some sozinho quando não dá.
 */
export function AndroidInstallButton({ className = '' }: { className?: string }) {
  const [available, setAvailable] = useState(() => canInstall());

  useEffect(() => onInstallChange(() => setAvailable(canInstall())), []);

  if (!available || isStandalone() || platform() !== 'android') return null;

  return (
    <button
      type="button"
      onClick={() => void promptInstall()}
      className={`flex h-11 w-full items-center justify-center gap-2 rounded-xl border border-primary/40 bg-primary/5 text-[14px] font-semibold text-primary ${className}`}
      data-testid="android-install"
    >
      <Download className="h-4 w-4" aria-hidden />
      Instalar o app na tela inicial
    </button>
  );
}
